module.exports = __webpack_public_path__ + "img/media-23.caa7283c.png";